import { Subject, fromEvent, merge } from 'rxjs';
import { buffer, debounceTime, tap } from 'rxjs/operators';
import { noop } from 'ui-components/default-props/noop';

const debounce$ = new Subject().pipe(debounceTime(3000));

// protect against undefined window when executing scripts in node
let unload$;
if (typeof window !== 'undefined') {
  unload$ = fromEvent(window, 'beforeunload');
} else {
  unload$ = new Subject();
}

const trigger$ = merge(debounce$, unload$);
trigger$.subscribe(noop);

/**
 * @typedef {object} Log
 * @property {string} msg
 * @property {object} metadata
 * @property {object} [context]
 */

/**
 * @type {import('rxjs').Subject<Log>}
 */
export const buffer$ = new Subject();

export const logs$ = buffer$.pipe(
  tap(() => debounce$.next()),
  buffer(trigger$),
);
